import api, { getData } from '@/axiosConfig'
import { status } from '../../helpers'
const gemnoteAPI = api()
import i18n from '../../internatinalization/i18n'

import {
  LOAD_SUBTEAMS_LIST,
  SET_SUBTEAMS_LIST,
  ADDING_NEW_SUBTEAM,
  SET_NEW_SUBTEAM,
  UPDATE_SUBTEAM,
  REMOVING_SUBTEAM,
  REMOVE_SUBTEAM_FROM_LIST,
  REMOVE_USER_FROM_SUBTEAM
} from '@/state/mutationTypes'

export default {
  async getTeamsList({ commit, dispatch }) {
    try {
      commit(LOAD_SUBTEAMS_LIST, status.LOADING)
      const response = await gemnoteAPI.get('team/subteams')
      const data = getData(response)
      let { included = [] } = response.data

      let users = included
        .filter(i => i.type === 'users')
        .map(user => {
          return { id: user.id, ...user.attributes }
        })

      let teamsList = data.map(team => {
        return {
          id: team.id,
          name: team.attributes.name,
          users: users.filter(user => user.subteam.id == team.id)
        }
      })
      commit(SET_SUBTEAMS_LIST, teamsList)
      commit(LOAD_SUBTEAMS_LIST, status.LOADED)
    } catch (error) {
      console.log(error)
      commit(LOAD_SUBTEAMS_LIST, status.LOADED)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('subteams.action.get-team-list-error')]
          },
          { root: true }
        )
      }
    }
  },
  async addSubTeam({ commit, dispatch }, name) {
    try {
      commit(ADDING_NEW_SUBTEAM, true)

      if (name === '') {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('validations.subteam-name-required')]
          },
          { root: true }
        )
        commit(ADDING_NEW_SUBTEAM, false)
        return
      }

      let body = {
        subteam: {
          name
        }
      }
      const response = await gemnoteAPI.post('team/subteams', body)
      const data = getData(response)
      let newSubTeam = {
        id: data.id,
        name: data.attributes.name,
        users: [...data.relationships.users.data]
      }

      commit(SET_NEW_SUBTEAM, newSubTeam)
      commit(ADDING_NEW_SUBTEAM, false)
      dispatch('modal/hideModal', null, { root: true })
    } catch (error) {
      console.log(error)
      commit(ADDING_NEW_SUBTEAM, false)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message[0]]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('subteams.action.adding-subteam-error')]
          },
          { root: true }
        )
      }
    }
  },
  async editSubTeam({ commit, dispatch }, subTeamObject) {
    try {
      let { id, name } = subTeamObject
      if (name === '') {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('validations.subteam-name-required')]
          },
          { root: true }
        )
        return
      }

      let body = {
        subteam: {
          name
        }
      }

      await gemnoteAPI.put(`team/subteams/${id}`, body)
      commit(UPDATE_SUBTEAM, subTeamObject)
    } catch (error) {
      console.log(error)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('subteams.action.editing-subteam-error')]
          },
          { root: true }
        )
      }
    }
  },
  async removeSubTeam({ commit, dispatch }, subTeamId) {
    try {
      commit(REMOVING_SUBTEAM, true)
      await gemnoteAPI.delete(`team/subteams/${subTeamId}`)
      commit(REMOVE_SUBTEAM_FROM_LIST, subTeamId)
      commit(REMOVING_SUBTEAM, false)
    } catch (error) {
      console.log(error)
      commit(REMOVING_SUBTEAM, false)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('subteams.action.deleting-subteam-error')]
          },
          { root: true }
        )
      }
    }
  },
  async addUserToTeam({ state, commit, dispatch }, { userId, subTeamId }) {
    try {
      let body = {
        subteam: {
          user_id: userId
        }
      }

      await gemnoteAPI.post(`team/subteams/${subTeamId}/members`, body)
      dispatch('getTeamsList')

      let { teamsList } = state
      let team = teamsList.find(team => team.id == subTeamId)
      if (team) {
        commit(
          'team/SET_NEW_SUBTEAM_FOR_MEMBER',
          {
            userId,
            id: team.id,
            name: team.name
          },
          { root: true }
        )
      }
    } catch (error) {
      console.log(error)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('subteams.action.add-user-to-subteam-error')]
          },
          { root: true }
        )
      }
    }
  },
  async removeUserFromSubTeam({ commit, dispatch, state }, { userId }) {
    try {
      // find the current team for this user
      let { teamsList } = state
      let foundUser = null
      let currentTeam = null

      for (let index = 0; index < teamsList.length; index++) {
        const team = teamsList[index]
        foundUser = team.users.find(
          user => parseInt(user.id) === parseInt(userId)
        )
        if (foundUser) {
          currentTeam = team
          break
        }
      }

      if (foundUser) {
        await gemnoteAPI.delete(
          `team/subteams/${currentTeam.id}/members/${userId}`
        )
        commit(REMOVE_USER_FROM_SUBTEAM, {
          userId,
          subTeamId: currentTeam.id
        })
        commit(
          'team/SET_NEW_SUBTEAM_FOR_MEMBER',
          {
            userId,
            id: -1,
            name: 'None'
          },
          { root: true }
        )
      }
    } catch (error) {
      console.log(error)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('subteams.action.remove-user-subteam-error')]
          },
          { root: true }
        )
      }
    }
  }
}
